<p-card [styleClass]="'ui-card'">
  @if (title()) {
    <ng-template pTemplate="title">
      <span class="ui-card__title">{{ title() | uiLabelTranslate }}</span>
    </ng-template>
  }
  <ng-template pTemplate="content">
    <ng-content />
  </ng-template>
</p-card>
